<template>
  <div
    class="studio-home"
    :class="`${selectedTemplate.config.studioBackgroundColorClass} ${
      selectedTemplate.config.studioTopPadding ? 'pad' : ''
    }`"
  >
    <HMToggleButtonGroup v-model="isTurnedOn" />
    <component
      v-if="studio"
      class="container"
      :is="selectedTemplate.component"
    ></component>
    <AddToHomeScreenBanner class="d-md-none add-to-home-screen-banner" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import AddToHomeScreenBanner from '@/web/components/pwa/AddToHomeScreenBanner';
import StudioHomeTemplateClassic from './StudioHomeTemplateClassic';
import StudioHomeTemplateModern from './StudioHomeTemplateModern';
import StudioHomeTemplateCards from './StudioHomeTemplateCards';
import StudioHomeTemplateBrandColor from './StudioHomeTemplateBrandColor';
import StudioHomeTemplateProductBanner from './StudioHomeTemplateProductBanner';

export default Vue.extend({
  name: 'StudioHome',
  components: {
    AddToHomeScreenBanner,
    StudioHomeTemplateClassic,
    StudioHomeTemplateModern,
    StudioHomeTemplateCards,
    StudioHomeTemplateBrandColor,
    StudioHomeTemplateProductBanner,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      selectedTemplate: 'studio/selectedTemplate',
    }),
  },
  methods: {},
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.studio-home {
  &.pad {
    @include media-breakpoint-up(sm) {
      padding-top: $shop-topbar-height;
    }
  }
}

.add-to-home-screen-banner {
  bottom: 70px;
}
</style>
